import React from 'react';
import { FocusRing } from 'react-aria';
import S from './Checkbox.styles';
const Checkbox = React.forwardRef(({ className, id, labelText, extraText, name, value, ...otherProps }, ref) => {
    const idValue = id ?? `${name}-${value}`;
    return (React.createElement(S.Container, { className: className },
        React.createElement(S.CheckboxItem, { htmlFor: id },
            React.createElement(FocusRing, { focusRingClass: "focus-ring" },
                React.createElement(S.CheckboxInput, { ref: ref, id: idValue, name: name, value: value, type: "checkbox", ...otherProps })),
            React.createElement(S.CheckboxText, null,
                React.createElement("span", { dangerouslySetInnerHTML: { __html: labelText } }),
                extraText && React.createElement("span", { "data-extra": true }, extraText),
                React.createElement(S.Tick, null)))));
});
Checkbox.displayName = 'Checkbox';
export default Checkbox;
